import * as React from "react"

export const TranslatorContext = React.createContext()
